interface FileInfo {
  id: string;
  originalName: string;
  mimeType: string;
  fileSize: number;
  url: string;
  thumbnailUrl?: string;
  type: 'image' | 'video' | 'document';
}

interface FileMessageProps {
  file: FileInfo;
  isFromUser: boolean;
}

export default function FileMessage({ file, isFromUser: _isFromUser }: FileMessageProps) {
  const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const getFileIcon = (type: string) => {
    switch (type) {
      case 'image':
        return '🖼️';
      case 'video':
        return '🎥';
      case 'document':
        return '📄';
      default:
        return '📎';
    }
  };

  const handleDownload = () => {
    window.open(file.url, '_blank');
  };

  if (file.type === 'image') {
    return (
      <div style={{
        maxWidth: '300px',
        borderRadius: '12px',
        overflow: 'hidden',
        backgroundColor: '#ffffff',
        border: '1px solid #e5e7eb',
        cursor: 'pointer'
      }} onClick={handleDownload}>
        <img
          src={file.thumbnailUrl || file.url}
          alt={file.originalName}
          style={{
            width: '100%',
            height: 'auto',
            display: 'block'
          }}
        />
        <div style={{
          padding: '8px 12px',
          borderTop: '1px solid #e5e7eb',
          backgroundColor: '#f9fafb'
        }}>
          <p style={{
            margin: 0,
            fontSize: '12px',
            color: '#6b7280',
            fontWeight: '500'
          }}>
            {file.originalName} • {formatFileSize(file.fileSize)}
          </p>
        </div>
      </div>
    );
  }

  if (file.type === 'video') {
    return (
      <div style={{
        maxWidth: '400px',
        borderRadius: '12px',
        overflow: 'hidden',
        backgroundColor: '#ffffff',
        border: '1px solid #e5e7eb'
      }}>
        <video
          controls
          style={{
            width: '100%',
            height: 'auto',
            display: 'block'
          }}
        >
          <source src={file.url} type={file.mimeType} />
          お使いのブラウザは動画再生をサポートしていません。
        </video>
        <div style={{
          padding: '8px 12px',
          borderTop: '1px solid #e5e7eb',
          backgroundColor: '#f9fafb'
        }}>
          <p style={{
            margin: 0,
            fontSize: '12px',
            color: '#6b7280',
            fontWeight: '500'
          }}>
            {file.originalName} • {formatFileSize(file.fileSize)}
          </p>
        </div>
      </div>
    );
  }

  // Document files
  return (
    <div
      style={{
        maxWidth: '300px',
        padding: '12px',
        borderRadius: '12px',
        backgroundColor: '#ffffff',
        border: '1px solid #e5e7eb',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
      }}
      onClick={handleDownload}
      onMouseEnter={(e) => {
        (e.target as HTMLElement).style.backgroundColor = '#f3f4f6';
      }}
      onMouseLeave={(e) => {
        (e.target as HTMLElement).style.backgroundColor = '#ffffff';
      }}
    >
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}>
        <div style={{
          fontSize: '24px',
          lineHeight: '1'
        }}>
          {getFileIcon(file.type)}
        </div>
        <div style={{ flex: 1 }}>
          <p style={{
            margin: '0 0 4px 0',
            fontSize: '14px',
            fontWeight: '500',
            color: '#374151'
          }}>
            {file.originalName}
          </p>
          <p style={{
            margin: 0,
            fontSize: '12px',
            color: '#6b7280'
          }}>
            {formatFileSize(file.fileSize)} • クリックしてダウンロード
          </p>
        </div>
        <div style={{
          fontSize: '16px',
          color: '#9ca3af'
        }}>
          <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
      </div>
    </div>
  );
} 